/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A button to display in the toast notification.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface ToastButton { 
    label: string;
    value: any | null;
}
export const ToastButton_label_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ToastButton_value_Validators: ValidatorFn[] =
    [  Validators.required, ];


